__turbopack_context__.v({
  "btnSyles": "RKFKXW_btnSyles",
  "container": "RKFKXW_container",
  "dateStyles": "RKFKXW_dateStyles",
  "mainTitle": "RKFKXW_mainTitle",
  "tagContaienr": "RKFKXW_tagContaienr",
  "tagbtnStyles": "RKFKXW_tagbtnStyles",
  "toasTextStyles": "RKFKXW_toasTextStyles",
  "videoText": "RKFKXW_videoText",
  "videoWrapper": "RKFKXW_videoWrapper",
});
